import Sticky from 'sticky-js'

export default {
  name: 'sticky',

  componentDidMount () {
    this.sticky = new Sticky('.sticky-wrap')
  },
}
